module.exports = __webpack_public_path__ + "img/media-psn@2x.22886c1a.png";